import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createHttpLink } from '@apollo/client/link/http';
import { setContext } from 'apollo-link-context';
import storage from './storage';

// Get runtime environment variables from window.__RUNTIME_ENV__ (injected by server)
// or fallback to @mars/heroku-js-runtime-env for backward compatibility
function getRuntimeEnv() {
  if (typeof window !== 'undefined' && window.__RUNTIME_ENV__) {
    return window.__RUNTIME_ENV__;
  }
  // Fallback for development or if runtime env not injected
  try {
    const runtimeEnv = require('@mars/heroku-js-runtime-env').default;
    return runtimeEnv();
  } catch (e) {
    // If runtime-env package fails, return empty object (will use defaults)
    return {};
  }
}

const env = getRuntimeEnv();
const API_VERSION = env.REACT_APP_API_VERSION || 'v1';
const HTTP = env.REACT_APP_HTTP_MODE || 'http';
const URI = `${HTTP}://${env.REACT_APP_URI || 'localhost:4000'}/${API_VERSION}`;

function fetchWithTimeout(uri, options = {}, time) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Request timed out.'));
    }, time);
    fetch(uri, options).then(
      (response) => {
        clearTimeout(timer);
        resolve(response);
      },
      (err) => {
        clearTimeout(timer);
        reject(err);
      },
    );
  });
}

const REQUEST_TIMEOUT = 120000;

// import gql from 'graphql-tag'
const apolloClient = {
  getClient: () => {
    const httpLink = createHttpLink({
      uri: `${URI}/graphql`,
      fetch: (uri, options) => (fetchWithTimeout(uri, options, REQUEST_TIMEOUT)),
    });

    const token = storage.getToken();

    const authLink = setContext((_, { headers }) => ({
      headers: {
        ...headers,
        authorization: token ? `${token}` : '',
      },
    }));

    const client = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });

    return client;
  },
};

export { URI };

export default apolloClient;



// WEBPACK FOOTER //
// ./src/providers/apolloClient.js